module.exports = __webpack_public_path__ + "static/img/courseware.078d5a3f.png";